// Mirrors the mobile app's light theme 1:1 — see
// react-native-projects/NameItApp/theme/themes/light.ts. Keep these two in
// sync; this is the source of truth for web until/unless web grows its own
// dark mode.
const light = {
  background: '#FEF2F2',
  surface: '#ffffff',
  surface2: '#f9fafb',
  text: '#1f2937',
  textSecondary: '#6b7280',
  textMuted: '#4b5563',
  border: '#e5e7eb',
  borderLight: '#f3f4f6',
  input: '#f3f4f6',
  accent: '#dc2626',
  accentMuted: '#fef2f2',
  iconBg: '#f3f4f6',
  white: '#ffffff',
  placeholder: '#9ca3af',
};

export default light;
